import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';

import { ColorsMenuComponent } from './colors-menu.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    FormsModule,
    MatMenuModule,
  ],
  declarations: [ColorsMenuComponent],
  exports: [ColorsMenuComponent],
  providers: [],
})
export class ColorsMenuModule {}
